<template>
  <SettingsPageLayout>
    <DetailForm
      class="mt-6"
      title="Billing"
      description="Manage your payment methods, see your billing history, etc."
      hideaction="true"
      hidecancel="true"
    >
      <div class="flex justify-end">
        <a
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          :href="session"
          target="_blank"
        >
          Manage Billing
        </a>
      </div>
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      session: '',
    };
  },
  mounted() {
    this.getBillingSession();
  },
  methods: {
    getBillingSession() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/billing_session`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.session = data.session;
        });
    },
  },
};
</script>
